<template>
  <div class="row" :class="{'section-loading': isLoading}">
    <div class="col-12">
      <h4 class="text-green text-center">保單價值</h4>
      <form class="form">
        <div class="panel panel-form searchArea">
          <div class="form-group row">
            <div class="ml-50 col-12 d-inline-grid">
              <div class="radio radio-inline ml-15 mb-15">
                <input
                  type="radio"
                  id="insuranceValue-1"
                  v-model="insuranceValue"
                  value="0"
                  />
                <label class="hide-label" for="insuranceValue-1"></label>
                <span class="ml-50 lh-40">保單價值為固定</span>
              </div>
              <div class="radio radio-inline ml-15 mb-15">
                <input
                  type="radio"
                  id="insuranceValue-2"
                  v-model="insuranceValue"
                  value="1"
                  />
                <label class="hide-label" for="insuranceValue-2"></label>
                <span class="lh-40 ml-50">保單價值</span>
                <input
                  type="number"
                  min="0"
                  max="999"
                  v-model="start_year"
                  @input="start_year = checkInputLength(start_year, 3)"
                  @blur="start_year = checkInputLength(start_year, 3)"
                  class="form-control form-control-inline show-input w-100"
                  :class="{'is-invalid': isYearError}"
                  />
                <span class="lh-40">年 ～</span>
                <input
                  type="number"
                  min="0"
                  max="999"
                  v-model="end_year"
                  @input="end_year = checkInputLength(end_year, 3)"
                  @blur="end_year = checkInputLength(end_year, 3)"
                  :class="{'is-invalid': isYearError}"
                  class="form-control form-control-inline show-input w-100"
                  />
                <span class="lh-40">年，投資報酬率於</span>
                <input
                  type="number"
                  max="99999999"
                  v-model="calculationbasisfirst_value"
                  @input="calculationbasisfirst_value = checkInputLength(calculationbasisfirst_value, 8)"
                  @blur="calculationbasisfirst_value = checkInputLength(calculationbasisfirst_value, 8)"
                  :class="{'is-invalid': isCalculationbasisError}"
                  class="form-control form-control-inline show-input w-100"
                  />
                <span class="lh-40"> % ～</span>
                <input
                  type="number"
                  max="99999999"
                  v-model="calculationbasissecond_value"
                  @input="calculationbasissecond_value = checkInputLength(calculationbasissecond_value, 8)"
                  @blur="calculationbasissecond_value = checkInputLength(calculationbasissecond_value, 8)"
                  :class="{'is-invalid': isCalculationbasisError}"
                  class="form-control form-control-inline show-input w-100"
                  />
                <span class="lh-40"> %，報酬率小數點</span>
                <select
                  v-model="rewardsrate_point"
                  class="form-control form-control-inline form-wide w-50"
                  >
                  <option value="0"></option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                </select>
              </div>
            </div>
          </div>
          <div class="text-center">
            <button type="button" class="btn btn-primary" @click="doUpdate" v-if="isEditMode">更新</button>
            <button type="button" class="btn btn-primary" @click="doInsert" v-else>新增</button>
            <button type="button" class="btn btn-default" @click="doCancel">取消</button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12 mt-40">
      <button type="button" class="btn btn-default" @click="doDeleteAll">全部刪除</button>
    </div>
    <div class="col-12">
      <table class="table datatable">
        <thead>
          <tr>
            <th class="text-center" style="width:15%;">排序</th>
            <th class="text-center" style="width:15%;">編輯/刪除</th>
            <th class="text-center" style="width:70%;">保障公式輸入結果</th>
          </tr>
        </thead>
        <tbody v-if="formulaData.length">
          <tr v-for="(item, i) in formulaData" :key="`formula-data-${item.investtype_formula_id}`">
            <td class="text-center" :class="{'active':editIndex === i}">
              <button
                type="button"
                class="btn btn-default fa fa-arrow-up"
                @click="doUpdatePriority(i,-1)"
                :disabled="i === 0 || isEditMode"
                >
              </button>
              <button
                type="button"
                class="btn btn-default fa fa-arrow-down"
                @click="doUpdatePriority(i, 1)"
                :disabled="i === formulaData.length-1 || isEditMode"
                >
              </button>
            </td>
            <td class="text-center" :class="{'active':editIndex === i}">
              <button 
                type="button" 
                class="btn btn-sm btn-primary" 
                :disabled="isEditMode" 
                @click="switchEditMode(item,i)"
                >
              編輯
              </button>
              <button 
                type="button" 
                class="btn btn-sm btn-default" 
                :disabled="isEditMode" 
                @click="doDelete(item)"
                >
              刪除
              </button>
            </td>
            <td :class="{'active':editIndex === i}">
              {{ item.formula_detail }}
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center" colspan="6">
              <h3 class="mb-3">查無保障公式</h3>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-5 mt-40" v-if="roiList.length">
      <table class="table datatable">
        <thead>
          <tr>
            <th class="text-center" style="width:24%;">計算年度</th>
            <th class="text-center" style="width:38%;">投資報酬率(小)</th>
            <th class="text-center" style="width:38%;">投資報酬率(大)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in roiList" :key="`invest-data-${i}`">
            <td>{{ item.year }}</td>
            <td>{{ item.invest_rewardsrate }}</td>
            <td>{{ item.invest_rewardsrate_to }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {
  getInvestValueFormula,
  addInvestFormula,
  deleteAllInvestFormula,
  deleteInvestFormula,
  updateInvestFormula,
  updateInvestFormulaPriority,
} from "@/service";

export default {
  name: "InvestPolicyValue",
  data() {
    return {
      productData: {},
      formulaData: [],
      roiList: [],
      insuranceValue: "0",
      originalInsuranceValue: "",
      rewardsrate_point: "0",
      start_year: null,
      end_year: null,
      calculationbasisfirst_value: null,
      calculationbasissecond_value: null,
      isYearError: false,
      isCalculationbasisError: false,
      isLoading: false,
      isEditMode: false,
      editIndex: -1,
      editFomulaId: "",
    };
  },
  computed: {
    //已有保單價值為固定值資料
    hasFixedValue() {
      return this.formulaData.filter((x) => x.formulatype == "0").length > 0;
    },
  },
  methods: {
    init() {
      this.formulaData = [];
      this.roiList = [];
      this.doCancel();
      this.isLoading = true;
      getInvestValueFormula(
        this.$store.state.userInfo.id,
        this.productData.productId
      ).then((result) => {
        if (result.header && result.header.status == "200") {
          this.formulaData = result.data.investformula.sort(
            (a, b) => parseInt(a.priority) - parseInt(b.priority)
          );
          this.roiList = result.data.roilist;
        }
        this.isLoading = false;
      });
    },
    doRound(value, scale) {
      return Math.round(value * 10 * scale) / (10 * scale);
    },
    doValidate() {
      let isError = false;
      this.isYearError = false;
      this.isCalculationbasisError = false;
      if (this.insuranceValue === "") {
        this.$toast.info({ title: "請選擇保單價值" });
        isError = true;
      }
      if (
        this.insuranceValue == "0" &&
        this.hasFixedValue &&
        !this.isEditMode
      ) {
        this.$toast.info({ title: "保單價值為固定值只能有一筆" });
        isError = true;
      }
      if (
        this.originalInsuranceValue != "0" &&
        this.insuranceValue == "0" &&
        this.hasFixedValue &&
        this.isEditMode
      ) {
        this.$toast.info({ title: "保單價值為固定值只能有一筆" });
        isError = true;
      }
      if (this.insuranceValue == "1") {
        if (
          !this.start_year ||
          !this.end_year ||
          this.start_year == 0 ||
          this.end_year == 0
        ) {
          this.isYearError = true;
          this.$toast.info({ title: "請輸入保單價值年度" });
          isError = true;
        }
        if (
          !this.calculationbasisfirst_value ||
          !this.calculationbasissecond_value
        ) {
          this.isCalculationbasisError = true;
          this.$toast.info({ title: "請輸入投資報酬率" });
          isError = true;
        }
      }
      return isError;
    },
    doInsert() {
      if (this.doValidate()) {
        return;
      }
      let reqData = this.getReqData();
      this.isLoading = true;
      addInvestFormula(this.$store.state.userInfo.id, reqData).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "新增成功" });
            this.init();
          } else {
            this.$toast.info({ title: result.header.message });
          }
          this.isLoading = false;
        }
      );
    },
    getReqData() {
      return {
        userId: this.$store.state.userInfo.mainUserId ? this.$store.state.userInfo.mainUserId : this.$store.state.userInfo.id,
        userName: this.$store.state.userInfo.mainUserId ? "" : this.$store.state.userInfo.name,
        productid: this.productData.productId,
        ageperiods: this.productData.ageperiods,
        terminableperiods: this.productData.terminableperiods,
        productname: this.productData.insuranceName,
        productcode: this.productData.insuranceCode,
        company: this.productData.company.COMPSNM,
        formulatype: this.insuranceValue,
        underwriting_target: "1", //1:本人
        yearperiod: "",
        year_type: "0",
        start_year: this.insuranceValue == "0" ? "0" : this.start_year,
        start_year_unit: "0",
        end_year: this.insuranceValue == "0" ? "0" : this.end_year,
        end_year_unit: "0",
        maxormin: "0",
        calculationbasis_first: "0",
        calculationbasisfirst_value:
          this.insuranceValue == "0" ? "0" : this.calculationbasisfirst_value,
        calculationbasisfirst_unit: this.insuranceValue == "0" ? "0" : "2",
        operator: "0",
        calculationbasis_second: "0",
        calculationbasissecond_value:
          this.insuranceValue == "0" ? "0" : this.calculationbasissecond_value,
        calculationbasissecond_unit: this.insuranceValue == "0" ? "0" : "2",
        rewardsrate_point: this.rewardsrate_point,
        priority:
          this.formulaData.length > 0
            ? parseInt(this.formulaData[this.formulaData.length - 1].priority) +
              1
            : 1,
        age_limt: "0",
        exchangerate_first: "0",
        exchangerate_second: "0",
      };
    },
    doUpdate() {
      if (this.doValidate()) {
        return;
      }
      let reqData = this.getReqData();
      reqData.investtype_formula_id = this.editFomulaId;
      updateInvestFormula(this.$store.state.userInfo.id, reqData).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "更新成功" });
            this.init();
          } else {
            this.$toast.info({ title: result.header.message });
          }
          this.isLoading = false;
        }
      );
    },
    doCancel() {
      if (this.isEditMode) {
        this.isEditMode = false;
        this.editIndex = -1;
        this.editFomulaId = "";
      }
      this.isYearError = false;
      this.isCalculationbasisError = false;
      this.insuranceValue = "0";
      this.rewardsrate_point = "0";
      this.start_year = null;
      this.end_year = null;
      this.calculationbasisfirst_value = null;
      this.calculationbasissecond_value = null;
    },
    switchEditMode(item, index) {
      this.isEditMode = true;
      this.isYearError = false;
      this.isCalculationbasisError = false;
      this.editIndex = index;
      this.editFomulaId = item.investtype_formula_id;
      this.insuranceValue = item.formulatype;
      this.originalInsuranceValue = item.formulatype;
      if (this.insuranceValue == "0") {
        this.rewardsrate_point = "0";
        this.start_year = null;
        this.end_year = null;
        this.calculationbasisfirst_value = null;
        this.calculationbasissecond_value = null;
      } else {
        this.start_year = item.start_year;
        this.end_year = item.end_year;
        this.calculationbasisfirst_value = item.calculationbasisfirst_value;
        this.calculationbasissecond_value = item.calculationbasissecond_value;
        this.rewardsrate_point = item.rewardsrate_point;
      }
    },
    doDeleteAll() {
      if (confirm("確認要刪除所有資料!?")) {
        this.isLoading = true;
        let deleteTypeList = [0, 1]; //0:保單價值(價值為固定值) 1:保單價值
        deleteAllInvestFormula(this.$store.state.userInfo.id, {
          productid: this.productData.productId,
          company: this.productData.company.COMPSNM,
          insuranceName: this.productData.insuranceName,
          insuranceCode: this.productData.insuranceCode,
          deletetypelist: deleteTypeList,
          detail: this.formulaData.map(x => x.formula_detail.replaceAll("%", "％")),
        }).then((result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "刪除成功" });
            this.init();
          } else {
            this.$toast.info({ title: "無保障公式可刪除" });
          }
          this.isLoading = false;
        });
      }
    },
    doDelete(item) {
      if (confirm("確認要刪除此筆資料!?")) {
        this.isLoading = true;

        let reqData = {
          productid: this.productData.productId,
          company: this.productData.company.COMPSNM,
          insuranceName: this.productData.insuranceName,
          insuranceCode: this.productData.insuranceCode,
          investtype_formula_id: item.investtype_formula_id,
          detail: item.formula_detail.replaceAll("%", "％"),
          userId: this.$store.state.userInfo.mainUserId ? this.$store.state.userInfo.mainUserId : this.$store.state.userInfo.id,
          userName: this.$store.state.userInfo.mainUserId ? "" : this.$store.state.userInfo.name,
        };
        deleteInvestFormula(this.$store.state.userInfo.id, reqData).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.$toast.info({ title: "刪除成功" });
              this.init();
            } else {
              this.$toast.info({ title: "無保障公式可刪除" });
            }
            this.isLoading = false;
          }
        );
      }
    },
    doUpdatePriority(index, shift) {
      let thisItem = this.formulaData.map(
        ({ formula_detail, ...keepAttrs }) => keepAttrs
      )[index];
      let targetItem = this.formulaData.map(
        ({ formula_detail, ...keepAttrs }) => keepAttrs
      )[index + shift];
      thisItem.priority = thisItem.priority + shift;
      targetItem.priority = targetItem.priority - shift;

      let reqList = [];
      reqList.push(thisItem);
      reqList.push(targetItem);

      this.isLoading = true;
      updateInvestFormulaPriority(this.$store.state.userInfo.id, reqList).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "更新成功" });
            this.init();
          } else {
            this.$toast.info({ title: result.header.message });
          }
          this.isLoading = false;
        }
      );
    },
    checkInputLength(value, length) {
      if (value.length > length) {
        return value.slice(0, length);
      }
      return value;
    },
  },
  beforeMount() {
    this.productData = JSON.parse(localStorage.productData);
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.mt-40 {
  margin-top: 40px;
}
.fs-12 {
  font-size: 12px;
}
.lh-40 {
  line-height: 40px;
}
.w-50 {
  width: 50px !important;
}
.w-100 {
  width: 100px !important;
}
.mb-15 {
  margin-bottom: 15px;
}
.ml-50 {
  margin-left: 50px !important;
}
.show-input {
  opacity: unset;
  position: unset;
}
.searchArea {
  border-color: #027a39;
  border-width: 3px;
  background-color: white;
}
.d-inline-grid {
  display: inline-grid;
}
.hide-label {
  height: 0;
}
.active {
  background-color: #f5dec5;
}
</style>
